<template>
    <span v-if="data">
        <span v-if="data.status" class="label-messages-icons">
            <svg v-if="data.status" class="message-icon" :class="data.status + '-icon'">
                <use :xlink:href="'/img/front/icons/svgmap.svg#' + data.status"/>
            </svg>
        </span>
        <span v-if="data.status && data.message" class="label-messages">
            <span class="field-message" :class="data.status + '-message'">
                {{ data.message }}
            </span>
        </span>
    </span>
</template>

<script>
    export default {
        props: {
            data: {
                required: false,
                default: null
            }
        },
    }
</script>